import { useEffect, useState } from 'react';

export interface UseAuth {
  isAuth: boolean;
}

export function useAuth(): UseAuth {
  const [isAuth, setIsAuth] = useState<boolean>(Boolean(global.localStorage.getItem('token')));

  useEffect(() => {
    window.addEventListener('storage', () => {
      setIsAuth(Boolean(global.localStorage.getItem('token')));
    });

    return () => {
      window.removeEventListener('storage', () => {
        setIsAuth(Boolean(global.localStorage.getItem('token')));
      });
    };
  }, []);

  return { isAuth };
}

export default useAuth;
